import RatingsAndReviews from 'components/ProductPage/RatingsAndReviews/RatingsAndReviews';

export default RatingsAndReviews;
